module.exports = __webpack_public_path__ + "img/bg.30145556.png";